export const CLASS_BACK_BUTTON = 'back-button';
